import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import { useTranslate } from '@above-the-treeline/localization';

CommunitiesSearch.propTypes = {
	isMobile: PropTypes.func,
	onChange: PropTypes.func,
	mobileWidth: PropTypes.string,
	desktopWidth: PropTypes.string,
	communitiesCount: PropTypes.number,
};

CommunitiesSearch.defaultProps = {
	desktopWidth: '50%',
	mobileWidth: '100%',
};

const CommunitiesQtyForDisplayingSearch = 5;

function CommunitiesSearch({
	onChange,
	isMobile,
	mobileWidth,
	desktopWidth,
	communitiesCount,
}) {
	const [value, setValue] = React.useState('');
	const { translate } = useTranslate();
	const isMobileSize = isMobile();
	const isVisible = communitiesCount
		? communitiesCount >= CommunitiesQtyForDisplayingSearch
		: true;

	const handleOnChange = e => {
		if (typeof onChange === 'function') onChange(e.target.value);
		setValue(e.target.value);
	};

	return isVisible ? (
		<div className="communities-search">
			<Input
				placeholder={translate('find_a_community')}
				value={value}
				style={{
					width: isMobileSize ? mobileWidth : desktopWidth,
				}}
				onChange={handleOnChange}
				allowClear
			/>
		</div>
	) : null;
}

export default withIsMobile(CommunitiesSearch);
